const ANALYTICS_CONSENT_KEY = "report360:analytics-consent";
const DEFAULT_MEASUREMENT_ID = "G-EHS3T92BVJ";

function measurementId() {
  return (
    process.env.REACT_APP_REPORT360_FIREBASE_MEASUREMENT_ID ||
    DEFAULT_MEASUREMENT_ID
  ).trim();
}

function ensureGoogleTag() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  const id = measurementId();
  if (!document.querySelector('script[data-report360-analytics="true"]')) {
    const script = document.createElement("script");
    script.async = true;
    script.dataset.report360Analytics = "true";
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
    document.head.appendChild(script);
  }

  window.gtag("consent", "default", {
    ad_personalization: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    analytics_storage: "denied",
  });
  window.gtag("js", new Date());
  window.gtag("config", id, {
    anonymize_ip: true,
    send_page_view: false,
  });
  return true;
}

export function getMarketingAnalyticsConsent() {
  if (typeof window === "undefined") return null;
  try {
    const choice = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
    return choice === "granted" || choice === "denied" ? choice : null;
  } catch {
    return null;
  }
}

export function setMarketingAnalyticsConsent(granted) {
  if (typeof window === "undefined") return false;

  const choice = granted ? "granted" : "denied";
  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, choice);
  } catch {
    return false;
  }

  if (granted) {
    ensureGoogleTag();
  }
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_personalization: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      analytics_storage: choice,
    });
  }
  return true;
}

export function trackMarketingPageView() {
  if (
    getMarketingAnalyticsConsent() !== "granted" ||
    typeof window === "undefined" ||
    typeof window.gtag !== "function"
  ) {
    return false;
  }

  const pagePath = window.location.pathname || "/";
  window.gtag("event", "page_view", {
    page_location: `${window.location.origin}${pagePath}`,
    page_path: pagePath,
    page_title: document.title || "Report360",
  });
  return true;
}

export function trackMarketingEvent(eventName, parameters = {}) {
  const normalizedEventName = String(eventName || "").trim();
  if (
    !normalizedEventName ||
    getMarketingAnalyticsConsent() !== "granted" ||
    typeof window === "undefined"
  ) {
    return false;
  }
  if (typeof window.gtag !== "function") {
    setMarketingAnalyticsConsent(true);
  }
  if (typeof window.gtag !== "function") return false;

  const safeParameters = {};
  for (const key of [
    "campaign",
    "currency",
    "interval",
    "market",
    "medium",
    "method",
    "plan_code",
    "quantity",
    "source",
    "value",
  ]) {
    const value = parameters[key];
    if (typeof value === "string" || typeof value === "number") {
      safeParameters[key] = value;
    }
  }
  window.gtag("event", normalizedEventName, safeParameters);
  return true;
}
